import moment from 'moment'
import 'moment/locale/vi'
import { languages } from '../../configs/language'
import { defaultTimeZone } from '../../configs/timeZone'
import { EMPTY_VALUE, localStorageKeys } from '../utils/common'

const { en, vi } = languages

export const changeLocaleDateTime = (locale) => {
  moment.locale(locale, {
    week: {
      dow: 1,
      doy: 7,
    },
  })
}

export const FORMAT = {
  DATE_TIME: {
    [en]: 'DD-MMM-YYYY HH:mm:ss',
    [vi]: 'DD/MM/YYYY HH:mm:ss',
  },
  DATE: {
    [en]: 'DD-MMM-YYYY',
    [vi]: 'DD/MM/YYYY',
  },
  DATE_INPUT: {
    [en]: 'DD/MM/YYYY',
    [vi]: 'DD/MM/YYYY',
  },
  TIME: {
    [en]: 'HH:mm:ss',
    [vi]: 'HH:mm:ss',
  },
  FILE: {
    [en]: 'YYYYMMDD',
    [vi]: 'YYYYMMDD',
  },
  DAY_MONTH: {
    [en]: 'DD-MMM',
    [vi]: 'DD/MM',
  },
  YEAR: {
    [en]: 'YYYY',
    [vi]: 'YYYY',
  },
  FILE_DOWNLOAD: {
    [en]: 'YYYYMMDDHHmmss',
    [vi]: 'YYYYMMDDHHmmss',
  },
  DATE_PICKER: {
    [en]: 'YYYY/MM/DD',
    [vi]: 'YYYY/MM/DD',
  },
  CURRENT_TIME: {
    [en]: 'hh:mm A DD MMMM YYYY',
    [vi]: 'hh:mm A DD [Tháng] MM YYYY',
  },
  MONTH_YEAR: {
    [en]: 'MMM-YYYY',
    [vi]: 'MM/YYYY',
  },
  MONTH: {
    [en]: 'MM',
    [vi]: 'MM',
  },
}

export const getCurrentDateTime = (format, locale = en, timeZone) => {
  const datetime = moment().utcOffset(timeZone || getTimeZoneLocal().offset)
  return format
    ? datetime.format(format[locale]).toString()
    : datetime.toISOString()
}

export const formatDateTime = (
  str,
  format = FORMAT.DATE_TIME,
  locale = en,
  timeZone,
) => {
  return !!str && moment(str).isValid()
    ? moment
        .utc(str)
        .utcOffset(timeZone || getTimeZoneLocal().offset)
        .format(format[locale])
        .toString()
    : EMPTY_VALUE
}

export const formatDateTimeLocal = (
  str,
  format = FORMAT.DATE_TIME,
  locale = en,
) => {
  return !!str && moment(str).isValid()
    ? moment(str).format(format[locale]).toString()
    : EMPTY_VALUE
}

export const getDateTimeFrom = (
  from,
  amount,
  unit,
  format,
  locale = en,
  timeZone,
) => {
  const datetime = moment
    .utc(from)
    .utcOffset(timeZone || getTimeZoneLocal().offset)
    .add(amount, unit)

  return format
    ? datetime.format(format[locale]).toString()
    : datetime.toISOString()
}

export const compareTwoDateTime = (date1, date2) => {
  if (moment(date1) > moment(date2)) return 1
  if (moment(date1) < moment(date2)) return -1
  return 0
}

export const getQuarter = (date = new Date()) => {
  return Math.floor(new Date(date).getMonth() / 3 + 1)
}

export const getTZMinutes = (strTimeZone) => {
  const timeZoneSign = strTimeZone[0]
  const timeZoneHour = Number(timeZoneSign + strTimeZone.substring(1, 3))
  const timeZoneMinute = Number(timeZoneSign + strTimeZone.substring(4, 6))
  return timeZoneHour * 60 + timeZoneMinute
}

export const getISOStartOrEndOfDay = (str, strTimeZone, isStartOfDay) => {
  const tzMinutes = getTZMinutes(strTimeZone)

  const dateTime = isStartOfDay
    ? moment(str).startOf('day')
    : moment(str).endOf('day')
  dateTime.subtract(tzMinutes, 'minutes')

  return (
    dateTime.format('YYYY-MM-DD[T]HH:mm') + (isStartOfDay ? ':00Z' : ':59Z')
  )
}

export const getDateWithTimezone = (date, timeZone) => {
  return moment(date).utcOffset(timeZone).toDate()
}

export const saveTimeZoneLocal = (timezone) => {
  localStorage.setItem(localStorageKeys.KEY_TIMEZONE, JSON.stringify(timezone))
}

export const getTimeZoneLocal = () => {
  const timezone = localStorage.getItem(localStorageKeys.KEY_TIMEZONE)
  return timezone ? JSON.parse(timezone) : defaultTimeZone
}

export const getDiffTime = (startTime, endTime) => {
  return moment(endTime).diff(moment(startTime), 'seconds')
}
